<div>
    <div class="instance-header"
         [ngClass]="{'session-instances-header-background':mySessionConfig.hasOwnProperty('my_schedule'),'my-session-header-background':!mySessionConfig.hasOwnProperty('my_schedule')}">
        <h4>
            <i class="fa fa-lg fa-bars bars-icon"  role="presentation"></i>
            <span [ngClass]="{'session-instances-header-label': mySessionConfig.hasOwnProperty('my_schedule'),'my-session-header-label':!mySessionConfig.hasOwnProperty('my_schedule')}" id="session-instances-label"
            >Instances</span>
        </h4>
    </div>
    <div class="instance-body">
        <div class="center-section center-position row">
            <h3>{{sessionName}}</h3>
        </div>

        <div #listViewContainer></div>
    </div>
    <div class="instance-footer">
        <button class="c-btn c-btn-primary my-session-button-primary"
                id="done-label" (click)="closeSessionInstances()">
            {{ 'my_schedule.done' | translate }}
        </button>
    </div>
</div>
